export enum EnumHeadingTextBlock {
  Heading_1 = 'HEADING_1',
  Heading_2 = 'HEADING_2',
  Heading_3 = 'HEADING_3',
  Heading_4 = 'HEADING_4',
  Heading_5 = 'HEADING_5',
  Heading_6 = 'HEADING_6',
}

export type FaqBackgroundColor = 'GREY' | 'PRIMARY_LIGHT' | 'WHITE';

export enum EnumRelevantArticleType {
  External = 'EXTERNAL',
  InternalArticle = 'INTERNAL_ARTICLE',
  InternalPage = 'INTERNAL_PAGE',
}

export enum EnumRelevantArticleGroupType {
  CompareProducts = 'COMPARE_PRODUCTS',
  LearnMore = 'LEARN_MORE',
  RelatedGuides = 'RELATED_GUIDES',
}

export type CurrencyPrefixType = 'SGD$' | 'HKD$' | 'NT$' | 'PHP' | '₱';

export enum EnumOrderTableItemComponentColumn {
  AnnualInterestRate = 'ANNUAL_INTEREST_RATE',
  ApplyButton = 'APPLY_BUTTON',
  ApprovalOdds = 'APPROVAL_ODDS',
  BankLogo = 'BANK_LOGO',
  EffectiveInterestRate = 'EFFECTIVE_INTEREST_RATE',
  GoogleRatings = 'GOOGLE_RATINGS',
  HandlingFee = 'HANDLING_FEE',
  HottestReward = 'HOTTEST_REWARD',
  InterestRate = 'INTEREST_RATE',
  IntroductoryAnnualRate = 'INTRODUCTORY_ANNUAL_RATE',
  IntroductoryMonthlyRepayment = 'INTRODUCTORY_MONTHLY_REPAYMENT',
  MaximumLoanAmount = 'MAXIMUM_LOAN_AMOUNT',
  MonthlyRepayment = 'MONTHLY_REPAYMENT',
  ProductName = 'PRODUCT_NAME',
  RewardValue = 'REWARD_VALUE',
  TotalInterestPayable = 'TOTAL_INTEREST_PAYABLE',
  WhyApplyNow = 'WHY_APPLY_NOW',
}

export type TravelInsuranceType = 'ANNUAL_PLAN' | 'SINGLE_PLAN';

export enum EnumProductBlockColorTag {
  Blue = 'BLUE',
  Gold = 'GOLD',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW',
}
/** Defines the type of button for car insurance product components. */
export enum CarInsuranceProductComponentButtonTypeEnum {
  Cta = 'CTA',
  Neutral = 'NEUTRAL',
  NeutralLightAndBlue = 'NEUTRAL_LIGHT_AND_BLUE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export enum UrlPrefixEnum {
  UseCampaign = 'USE_CAMPAIGN',
  UsePrimaryVertical = 'USE_PRIMARY_VERTICAL',
}

export enum UrlTargetEnum {
  Blank = 'BLANK',
  Parent = 'PARENT',
  Self = 'SELF',
  Top = 'TOP',
}

export enum ExclusiveOfferBadgeColorEnum {
  Blue = 'BLUE',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW',
}

export enum ExclusiveOfferTypeEnum {
  Flash = 'FLASH',
  Default = 'DEFAULT',
  Websitecampaign = 'WEBSITECAMPAIGN',
}

export type ProductDetailsRenderingModeEnum =
  | 'FULL_PAGE'
  | 'MODAL'
  | 'TI_PROVIDER';

export type ProductDetailsBenefitCategorySelectorEnum =
  | 'AIRMILES'
  | 'CASHBACK'
  | 'EMPTY'
  | 'REWARDS_POINTS';

// CMS-1935: fixed section slots of the config-driven Product Details layout.
export type PdpSectionSlotEnum =
  | 'OFFERS'
  | 'HIGHLIGHTS'
  | 'RATES_FEES'
  | 'FEATURES_PLATFORM'
  | 'ELIGIBILITY_APPLY';
